// Components==============
import ProgressBar from 'components/UI/ProgressBar/ProgressBar';
import React, { useContext, useEffect } from 'react';
import { FlashContext } from '../Flash';
import './TimerBar.module.scss';
// =========================

export default function TimeBar({ hide }: { hide: boolean }) {
    const { barStatus, setBarStatus, exercise } = useContext(FlashContext);

    const time = exercise?.pivot?.total_duration;

    useEffect(() => {
        if (barStatus === 'loading') {
            const timer = setTimeout(() => {
                setBarStatus('loaded');
            }, time);

            return () => clearTimeout(timer);
        }
    }, [barStatus]);

    const timerVariants = {
        initial: {
            x: '0%',
        },
        loading: {
            x: '-100%',
            transition: {
                duration: time ? time / 1000 : 100,
                ease: 'linear',
            },
        },
        loaded: {
            x: '-100%',
        },
    };

    return hide ? null : (
        <div styleName="wrapper">
            <ProgressBar
                timeProps={
                    time
                        ? { variants: timerVariants, animate: barStatus }
                        : undefined
                }
            />
        </div>
    );
}
